import { t } from 'i18next'

export const webhookEventTypes = ['candidate.created', 'candidate.message', 'candidate.rated'] as const

export function webhookEventTypeLabel(eventType: string) {
    switch (eventType) {
        case 'candidate.created':
            return t('Candidate created')
        case 'candidate.message':
            return t('Candidate message')
        case 'candidate.rated':
            return t('Candidate rated')
        default:
            return eventType
    }
}
